var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Watch } from 'vue-property-decorator';
import { mixpanelTracking } from '@/services/mixpanel';
import { getVideosCRM } from '@/shared/utils/Infosets.utils';
import { NotificationService } from '@/services/NotificationService';
import { verifyBitrix24Url } from '@/clients/crm';
import Modal from 'components/Modal.vue';
import Tooltip from 'components/Tooltip.vue';
import CrmCardContent from 'components/CrmCardContent.vue';
let Bitrix24ConfigCard = class Bitrix24ConfigCard extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.url = '';
        this.urlVerified = false;
        this.ocultedToken = true;
        this.openModal = false;
        this.crmIcon = 'statics/images/logos/bitrix24-logo.webp';
        this.companyFields = [
            'Razão Social/Nome Fantasia',
            'CNPJ',
            'Setor',
            'Cnae Primário',
            'Cnae Secundário',
            'Data de Abertura',
            'Faixa de Faturamento da Unidade CNPJ',
            'Faixa de Faturamento da Empresa',
            'Faixa de Funcionários da Unidade CNPJ',
            'Faixa de Funcionarios da Empresa',
            'Natureza Jurídica',
            'Administrador',
            'Facebook',
            'Website',
            'Todos os telefones',
            'Telefones atendidos',
            'Todos os Emails',
            'Decisores',
            'Endereço',
            'Situação',
        ];
        this.decisorFields = [
            'Nome',
            'E-mail',
            'Empresa',
            'Posição',
            'Nível de decisão',
            'Link do linkedIn',
        ];
        this.questions = [
            {
                question: 'Quais planos permitem exportação?',
                answer: 'Professional ou Enterprise.',
            },
            {
                question: 'Qual nível de permissão meu usuário precisa ter?',
                answer: 'Administrador ou usuário que possa criar e editar empresas, contatos e negócios.',
            },
            {
                question: 'Onde encontrar os dados das empresas?',
                answer: 'No menu lateral esquerdo vai em CRM, em seguida clica em Clientes no menu superior e depois em Empresas.',
            },
            {
                question: 'Onde encontrar os dados dos decisores?',
                answer: 'No menu lateral esquerdo vai em CRM, em seguida clica em Clientes no menu superior e depois em Contatos.',
            },
            {
                question: 'Onde ficam os dados dos Negócios?',
                answer: 'No menu principal, é a primeira opção "Negócio".',
            },
            {
                question: 'Como identificar onde o negócio foi criado?',
                answer: 'O negócio criado em sua conta, estará disponível no Pipeline e na Etapa que você selecionou antes de realizar a exportação.',
            },
            {
                question: 'O que acontece se eu exportar 2 vezes a mesma empresa?',
                answer: 'Nosso integrador irá atualizar os dados da empresa baseado no campo de cnpj e os contatos baseado no campo linkedin e email. O negócio não será atualizado.',
            },
        ];
    }
    get tutorialVideoLink() {
        return getVideosCRM('bitrix24');
    }
    changedOpenModal() {
        this.ocultedToken = true;
    }
    async verifyUrl() {
        this.loading = true;
        try {
            await verifyBitrix24Url({ url: this.url });
            this.urlVerified = true;
            this.ocultedToken = true;
            NotificationService.success('Sucesso', 'Sua url de integração foi salva com sucesso. Agora você pode exportar para o crm!');
        }
        catch (e) {
            const message = (e.response && e.response.data && e.response.data.message) ||
                'Ocorreu um erro inesperado';
            NotificationService.error('Error', message);
        }
        this.loading = false;
    }
    changeToken() {
        this.url = '';
        this.urlVerified = false;
        mixpanelTracking('integrações: Token Bitrix24 alterado');
    }
};
__decorate([
    Watch('openModal')
], Bitrix24ConfigCard.prototype, "changedOpenModal", null);
Bitrix24ConfigCard = __decorate([
    Component({
        name: 'Bitrix24ConfigCard',
        components: {
            Modal,
            Tooltip,
            CrmCardContent,
        },
    })
], Bitrix24ConfigCard);
export default Bitrix24ConfigCard;
